import { FormattedMessage, useIntl } from 'react-intl'

import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { ActivitySales } from 'features/Carts/components/ActivitySales'
import { ConciliationStatus } from 'features/Inventories/components/ConciliationStatus'
import { DEFAULT_TIMEZONE } from 'utils/date'

export const CartActivityList = ({ activityItems = [] }): TSFixMe => {
  const intl = useIntl()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            <Th>
              <FormattedMessage id="spanish.cart.activity.list.username" defaultMessage="Usuario" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.cart.activity.list.name" defaultMessage="Nombre" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.cart.activity.list.acceptedAt" defaultMessage="Inicio" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.cart.activity.list.logoutAt" defaultMessage="Final" />
            </Th>

            <Th>
              <FormattedMessage
                id="spanish.cart.activity.list.conciliationStatus"
                defaultMessage="Estado de conciliación"
              />
            </Th>

            <Th>
              <FormattedMessage id="spanish.cart.activity.list.sales" defaultMessage="Ventas" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.cart.activity.list.amount" defaultMessage="Monto vendido" />
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {activityItems.map((activity: TSFixMe): TSFixMe => {
            return (
              <Tr key={activity.id}>
                <Td>{activity.user.username}</Td>

                <Td>
                  {activity.user.firstName} {activity.user.lastName}
                </Td>

                <Td>
                  <div>
                    <FormattedDate
                      intl={intl}
                      value={activity.borrowedAt}
                      month="2-digit"
                      day="2-digit"
                      year="numeric"
                      timeZone={DEFAULT_TIMEZONE}
                    />
                  </div>

                  <div>
                    <FormattedTimeByDate intl={intl} date={activity.borrowedAt} timeZone={DEFAULT_TIMEZONE} />
                  </div>
                </Td>

                <Td>
                  {activity.returnedAt ? (
                    <>
                      <div>
                        <FormattedDate
                          intl={intl}
                          value={activity.returnedAt}
                          month="2-digit"
                          day="2-digit"
                          year="numeric"
                          timeZone={DEFAULT_TIMEZONE}
                        />
                      </div>

                      <div>
                        <FormattedTimeByDate intl={intl} date={activity.returnedAt} timeZone={DEFAULT_TIMEZONE} />
                      </div>
                    </>
                  ) : (
                    '-'
                  )}
                </Td>

                <Td>
                  <ConciliationStatus status={activity.conciliationStatus} />
                </Td>

                <Td>
                  <ActivitySales sales={activity.sales} />
                </Td>

                <Td>{activity.amount ? <FormattedPrice value={activity.amount} /> : '-'}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
